export * from './header/profile-header.wrapper.component';
export * from './info/profile-info-wrapper.component';
export * from './designation/designation-wrapper.component';
export * from './contact/contact-wrapper.component';
